var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('modal-provider',{attrs:{"name":"warning-modal","width":600,"classList":"warning-modal","title":_vm.warningTitle},on:{"before-open":_vm.beforeModalOpen}},[_c('span',{staticClass:"warning-text"},[_vm._v(_vm._s(_vm.warningText))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }